import { apiTokensApi } from "./apiTokens";

export const {
  useGetApiTokensQuery,
  useCreateApiTokenMutation,
  useRevokeApiTokenMutation
} = apiTokensApi;
